// extracted by mini-css-extract-plugin
export var connectionButton = "_bx-1";
export var connectionButtonFloating = "_bx-2";
export var connectionContainer = "_bx-0";
export var rightPanel = "_bx-6";
export var stepCard = "_bx-3";
export var stepCardSubtitle = "_bx-5";
export var stepCardText = "_bx-4";